module.exports = __webpack_public_path__ + "static/media/verificaçãoDocError.b263c4de.jpg";